import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
// Commented out unused imports
// import { motion } from "framer-motion";
import { Menu, X } from "lucide-react"; // Removed unused Search import

// Navigation links - moved to footer, keeping empty for future use
const navLinks = [];

export default function Header() {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  return (
    <header className="w-full px-4 md:px-16 flex items-center justify-between bg-gray-100 relative">
      {/* Logo */}
      <Link to="/" className="flex items-center gap-2 font-bold text-2xl py-4">
        <span className="text-black">JOB</span>
        <span className="text-black">LO<span className="text-yellow-400">OP</span></span>
      </Link>
      
      {/* Navigation */}
      <nav className="hidden md:flex items-center">
        {navLinks.map(link => (
          <Link
            key={link.name}
            to={link.to}
            className={`px-6 py-4 text-sm font-bold transition-colors ${location.pathname === link.to ? 'bg-yellow-400 text-white border-t-0' : 'text-black hover:bg-yellow-400 hover:text-white'}`}
            style={{ marginTop: '-4px', paddingTop: '20px' }} // Make the highlight touch the top
          >
            {link.name}
          </Link>
        ))}
      </nav>
      
      {/* Right Side Items */}
      <div className="flex items-center py-4 gap-4">
        {/* Pricing Button */}
        <Link 
          to="/pricing" 
          className="hidden md:flex items-center px-4 py-2 border-2 border-black text-black font-bold text-sm hover:bg-black hover:text-white transition-colors"
          onClick={(e) => {
            e.stopPropagation();

          }}
        >
          PRICING
        </Link>
        
        {/* Combined Login/Signup Button */}
        <div className="hidden md:flex items-center">
          <Link 
            to="/auth/candidate" 
            className="px-4 py-2 bg-yellow-400 text-black font-bold text-sm hover:bg-yellow-500 transition-colors flex items-center"
          >
            CANDIDATE LOGIN
          </Link>
        </div>
        
        {/* For Employers Link */}
        <Link 
          to="/auth/employer" 
          className="hidden md:flex items-center px-4 py-2 bg-black text-white font-bold text-sm hover:bg-gray-900 transition-colors"
        >
          EMPLOYER LOGIN
        </Link>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden p-2 focus:outline-none"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? (
            <X className="h-6 w-6 text-black" />
          ) : (
            <Menu className="h-6 w-6 text-black" />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 bg-white z-50 border-t border-gray-200 shadow-lg">
          <div className="flex flex-col">
            {navLinks.map(link => (
              <Link
                key={link.name}
                to={link.to}
                className={`px-6 py-4 text-sm font-bold transition-colors ${location.pathname === link.to ? 'bg-yellow-400 text-white' : 'text-black hover:bg-yellow-50'}`}
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.name}
              </Link>
            ))}
            {/* Pricing Link */}
            <Link 
              to="/pricing" 
              className="px-6 py-4 text-sm font-bold text-black hover:bg-yellow-50 transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              PRICING
            </Link>
            
            {/* Candidate Login Button */}
            <Link 
              to="/auth/candidate" 
              className="px-6 py-4 text-sm font-bold text-black hover:bg-yellow-50 transition-colors border-t border-gray-200"
              onClick={() => setMobileMenuOpen(false)}
            >
              CANDIDATE LOGIN
            </Link>
            
            {/* Employer Login Link */}
            <Link 
              to="/auth/employer" 
              className="px-6 py-4 text-sm font-bold text-black hover:bg-yellow-50 transition-colors border-t border-gray-200"
              onClick={() => setMobileMenuOpen(false)}
            >
              EMPLOYER LOGIN
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
